import FormTips from './FormTips'

export default FormTips
